var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-container"},[_c('paragraph',{attrs:{"text":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }